//@flow
import * as Immutable from 'immutable';

import { ResourceLimit } from 'common/models/flow/ResourceLimit';
import type { ResourceLimitModelType } from 'common/models/flow/ResourceLimit';
import {
    validatable,
    validate,
    validateAll,
    softValidateAll
} from 'common/utils/ValidationUtil';
import DataUtils from 'common/utils/DataUtils';
import NumberUtils from 'common/utils/NumberUtils';
import I18nHelper from 'common/helpers/I18nHelper';

const translationsNamespace = ['validations'];
const nsTranslate = I18nHelper.getTranslate(translationsNamespace);

@validatable
class InternalResourceLimit extends ResourceLimit {
    static fromJS(json: ResourceLimitModelType): InternalResourceLimit {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    @softValidateAll
    hasValidationErrors(): boolean {
        return false;
    }

    @validateAll
    setAllValidationErrors(): this {
        return this;
    }

    @validate
    setHigherThresh(higherThresh: number): this {
        return super.setHigherThresh(higherThresh);
    }

    validateHigherThresh() {
        const { higherThresh, lowerThresh } = this;
        if (
            DataUtils.isEmpty(higherThresh) &&
            !DataUtils.isEmpty(lowerThresh)
        ) {
            return nsTranslate('resourceLimit.maxLimitEmpty');
        }
        if (
            !DataUtils.isEmpty(higherThresh) &&
            !NumberUtils.isNumeric(higherThresh)
        ) {
            return nsTranslate('resourceLimit.limitNotANumber');
        }

        if (
            !DataUtils.isEmpty(higherThresh) &&
            !NumberUtils.isNonNegativeNumber(higherThresh)
        ) {
            return nsTranslate('resourceLimit.limitNotANegativeNumber');
        }

        if (
            NumberUtils.isNumeric(lowerThresh) &&
            NumberUtils.isNumeric(higherThresh) &&
            NumberUtils.toNumber(lowerThresh) >
                NumberUtils.toNumber(higherThresh)
        ) {
            return nsTranslate('resourceLimit.maxLesserThanMin');
        }
    }

    @validate
    setLowerThresh(lowerThresh: number): this {
        return super.setLowerThresh(lowerThresh);
    }
    validateLowerThresh() {
        const { lowerThresh, higherThresh } = this;
        if (
            !DataUtils.isEmpty(lowerThresh) &&
            !NumberUtils.isNumeric(lowerThresh)
        ) {
            return nsTranslate('resourceLimit.limitNotANumber');
        }

        if (
            !DataUtils.isEmpty(lowerThresh) &&
            !NumberUtils.isNonNegativeNumber(lowerThresh)
        ) {
            return nsTranslate('resourceLimit.limitNotANegativeNumber');
        }

        if (
            NumberUtils.isNumeric(lowerThresh) &&
            NumberUtils.isNumeric(higherThresh) &&
            NumberUtils.toNumber(lowerThresh) >
                NumberUtils.toNumber(higherThresh)
        ) {
            return nsTranslate('resourceLimit.minGreaterThanMax');
        }
    }

    static defaultInit(): InternalResourceLimit {
        return InternalResourceLimit.fromJS({
            name: 'task',
            unit: 'COUNT',
            lowerThresh: null,
            higherThresh: null
        });
    }
}

export { InternalResourceLimit as ResourceLimit };
